import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from '../actions';
import '../App.css';

import EmbedCalendarScreen from '../screens/EmbedCalendarScreen';
import WooCalendarScreen from '../screens/WooCalendarScreen';
import CourseScreen from '../screens/CourseScreen';
import LoginScreen from '../screens/LoginScreen';
import StudentsScreen from '../screens/StudentsScreen';
import SingleStudentScreen from '../screens/SingleStudentScreen';
import CatchAllScreen from '../screens/CatchAllScreen';

interface AppProps {
  fetchUser: any;
}

class App extends Component<AppProps> {
  componentDidMount() {
    this.props.fetchUser(); // fetches the current user
  }

  render() {
    return (
      <BrowserRouter>
        {/* <Route exact path="/" component={CalendarScreen} /> */}
        <Route exact path="/calendar" component={EmbedCalendarScreen} />
        <Route exact path="/calendar-woo" component={WooCalendarScreen} />
        <Route exact path="/courses/:id" component={CourseScreen} />
        <Route exact path="/login" component={LoginScreen} />
        <Route exact path="/" component={StudentsScreen} />
        <Route exact path="/student/:id" component={SingleStudentScreen} />
        {/* <Route exact path="/:id" component={CatchAllScreen} /> */}
      </BrowserRouter>
    );
  }
}

export default connect(null, actions)(App);
